/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import {
	StyleSheet,
} from "react-native";

import Style from "ae-style";
import StyledText from "ae-base/Base/StyledText";
import BlockView from "ae-base/Base/BlockView";

import Breakpoints from "react-native-dimensions-breakpoints";

import { useResources } from "@aetonix/hooks";
import { useBigger } from "../../Context/useBigger";

const styles = StyleSheet.create({
	container: {
		marginBottom: Style.layout.marginContentSmall
	}
});

const IS_TITLE_TYPES = [
	"array",
	"object"
];

const IGNORE_TITLE_FORMATS = [
	"time"
];

const IGNORE_TITLE_INPUTS = [
	"time",
	"days",
	"checkboxes"
];

export default function InputLabel(props){
	const { localize, localizeFrom } = useResources();
	const bigger = useBigger();
	const schema = props.schema;

	const ignoreObjectStyle = props.ignoreObjectStyle || schema.ignoreObjectStyle;
	const isObject = ignoreObjectStyle ? false : (IS_TITLE_TYPES.indexOf(schema.type) !== -1 || props.title) && (IGNORE_TITLE_FORMATS.indexOf(schema.format) === -1 && IGNORE_TITLE_INPUTS.indexOf(schema.inputType) === -1);

	const children = props.children;
	const description = schema.description;
	const labelStyle = props.labelStyle;

	let bold = false;
	let textSize = props.textSize;

	if(bigger) {
		textSize = "emphasized";
	} else if(isObject){
		bold = true;
		if(Breakpoints.smallerThan("small"))
			textSize = "small";
		else if(Breakpoints.smallerThan("mobile"))
			textSize = "standard";
		else
			textSize = "emphasized";
	}

	let label;
	if(schema.localization){
		label = localizeFrom(schema.localization, ".");
	} else if(description) {
		label = localize(description) || description;
	} else {
		return null;
	}

	return (
		<BlockView style={styles.container}>
			<StyledText bold={bold} size={textSize} light={props.contrast} style={labelStyle}>
				{label}
			</StyledText>
			{children}
		</BlockView>
	);
}